import { createCacheStore } from '@lib/utils/cache';
import { ShiftTypeService } from '@api/ShiftTypeService';

/** Cached ShiftTypeService.getShiftTypes(departmentId) reads. */
export const shiftTypesCache = createCacheStore(
    'shiftType/shiftTypes',
    ShiftTypeService.getShiftTypes,
);

/** Drops the cached shift types of a department (after shift type mutations). */
export const invalidateShiftTypes = (departmentId: string): void => {
    shiftTypesCache.invalidate(departmentId);
};

/** Drops all cached shift type data (department switch, full clears). */
export const invalidateShiftTypeData = (): void => {
    shiftTypesCache.invalidateAll();
};
